<template>
  <div class="discussWrap">
    <div class="discussbox">
      <div class="discussHeader">
        <div class="discussHeaderLeft">
          <el-input v-model="bbsForm.title" :placeholder="$t('Enter the title here')"/>
        </div>
        <div class="discussHeaderRight">
          <el-button class="nothBtnA" size="small" @click="cancelHandle">{{$t('Cancel')}}</el-button>
          <el-button class="mainBtn" size="mini"  @click="submitHandle">{{type | typeFilter(te)}}</el-button>
        </div>
      </div>
       <div class="discussTag" v-if="source=='discuss'">
        <div class="discussTagLeft">
          <div class="discussTagLeftText">#{{$t('Belonging to')}}：</div>
        </div>
        <div class="discussTagRight">
          <el-select v-model="bbsForm.category" popper-class="selectFormPoppers" :placeholder="$t('Please select type')" size="small" class="selectTopic">
            <el-option
              v-for="item in categoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="discussMarkDown">
        <editer ref="editer"></editer>
      </div>
    </div>
  </div>
</template>

<script>
  import editer from '@/components/markdown/bbs.vue';
  import {getAjax, postAjax} from '@/api/index.js';
  export default{
    props:{
      source:'',
      type:'',
    },
    data(){
      return{
        params:this.$route.params,
        bbsForm:{
          type:this.type,
          bbsid:'',
          title:'',
          content:'',
          source:this.source,
          category:3,
          source_resid:''
        },
        categoryList:[
          // {
          //   label:this.$t('Course'),
          //   value:2
          // },
          {
            label:'交流社区',
            value:3
          },
        ],
      }
    },
    created(){


    },
    components: {
      editer
    },
    methods:{


      setBbsForm(data){
        this.bbsForm.title = data.title;
        this.bbsForm.content =data.content;
        this.bbsForm.bbsid =data.bbsid;
        this.bbsForm.category =data.category;
        this.$refs.editer.setText(data.content)
        this.bbsForm.source_resid =data.source_resid;
      },
      cancelHandle(){
        this.$emit("closeDiscuss");
      },
      submitHandle(){
        this.bbsForm.content = this.$refs.editer.getText();
        if (!this.bbsForm.title) {
          this.$message({ type: 'warning', message:this.$t('Please enter a title'), duration: 2000 });
          return ;
        }
        if (!this.bbsForm.content) {
          this.$message({ type: 'warning', message: this.$t('Please enter content'), duration: 2000 });
          return ;
        }
        // return
        postAjax( "/bbs/postBbs",this.bbsForm).then((res) => {
          if (res.code == 1) {
            this.$message({ type: 'success', message: res.msg, duration: 2000 });
            this.$emit("confirmDiscuss",this.bbsForm);
          } else {
            this.$message({ type: 'error', message: res.msg, duration: 2000 });
          }
        });

      },
      te(key){
          return this.$t(key);
      }

    },
    filters: {
      typeFilter(val,te){
        var str=''
        if(val=='create'){
          str=te('Release')
        }else if(val=='update'){
          str=te('save')
        }else{
          str=te('Release')
        }
        return str
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/homepage/teachspace/replay.scss'

</style>



// WEBPACK FOOTER //
// src/page/Public/Exchange/discuss.vue